// src/pages/subscription/DiscountCreatePage.tsx
// Legacy route kept resolvable for old links/bookmarks. Discount creation now
// happens through DiscountFormDialog (form-kit), opened from DiscountListPage's
// "Create discount" — see docs/ux/14-forms.md. This route just sends people there.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const DiscountCreatePage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/subscriptions/discounts', { replace: true });
  }, [navigate]);
  return null;
};

export default DiscountCreatePage;
